(function ($) {

    let filter = {};

    function GenreTaxonomy(options) {
        console.log('GenreTaxonomy initialization');

        if (!options) {
            throw new Error('No options passed to GenreTaxonomy constructor');
        } else if (!options.apiRoute) {
            throw new Error('No option apiRoute passed to GenreTaxonomy constructor');
        } else if (!options.genreID) {
            throw new Error('No option genreID passed to GenreTaxonomy constructor');
        }

        this.options = $.extend({}, GenreTaxonomy.defaults, options);
        filter.taxonomyTermID = options.genreID;

        this.setup();
    }

    GenreTaxonomy.prototype.setup = function () {
        let body = $('body');
        let self = this;
        body.on('click', '.book-filter-tab a', function (event) {
            event.preventDefault();
            let orderBy = $(this).data('order-by');
            console.log(orderBy);
            filter.orderBy = orderBy;
            self.setActiveLink($(this));
            self.sendRequest()
        });
    }

    GenreTaxonomy.prototype.setActiveLink = function (activeLink) {
        let links = $('.book-filter-tab a');
        $.each(links, function (key, link) {
            $(link).removeClass('active');
        });
        activeLink.addClass('active');
    }

    /**
     * Send AJAX request
     */
    GenreTaxonomy.prototype.sendRequest = function () {
        let self = this;
        console.log('Send request');
        console.log(filter);

        jQuery.ajax({
            type: 'POST',
            url: self.options.apiRoute,
            data: filter,
            dataType: "json",
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-WP-Nonce', self.options.nonce);
                $('#message').hide().empty();
            },
            success: function (response) {
                self.parseResponse(response);
            },
            error: function (data) {
                console.log(data);
            }
        });
    }

    GenreTaxonomy.prototype.parseResponse = function (response) {
        console.log(response);
        if (response.status) {
            let data = response.data;
            let gc = $('#genre-content');
            let gnf = $('#genre-nothing-found');
            if (!data) {
                gc.hide().empty();
                gnf.show();
            } else {
                gc.empty().show().append(response.data);
                gnf.hide();
            }
        } else {
            console.log('Bad response');
        }
    };

    GenreTaxonomy.defaults = {};
    window.GenreTaxonomy = GenreTaxonomy;

})(jQuery);